import React from 'react';

import { useAppSelector } from '../../redux/hooks';

import CreateAccount from './CreateAccount';
import LoginForm from './LoginForm';
import ResetRequestForm from './ResetRequestForm';

interface OwnProps {
  closeLoginModal: () => void;
  showLoginMsg?: boolean;
}
const AuthenticationContainer = (props: OwnProps) => {
  const authState = useAppSelector((state) => state.auth.authState);

  if (authState === 'create') {
    return (
      <CreateAccount
        close={props.closeLoginModal}
        showLoginMsg={props.showLoginMsg}
      />
    );
  } else if (authState === 'reset') {
    return <ResetRequestForm close={props.closeLoginModal} />;
  } else {
    return <LoginForm close={props.closeLoginModal} />;
  }
};

export default AuthenticationContainer;
